import axios from "axios";
import { baseURL } from "../Constants";

export interface LiveChannel {
    login: string;
    name: string;
    live: boolean;
}

export const getTwitchLive = async (): Promise<LiveChannel[]> => {
    const response = await axios.get(`${baseURL}/TwitchLive`);
    return response.data;
};
